import { safeStringify } from './safeStringify';

export function toError(value: unknown): Error {
  return value instanceof Error ? value : new Error(safeStringify(value));
}
